<div
  [class]="
    'flex items-center justify-center rounded-full bg-(--avatar-background) overflow-hidden ' + sizeClass[config().size]
  "
>
  @if (resolvedImageUrl()) {
    <img
      [src]="resolvedImageUrl()"
      alt="Avatar"
      class="size-full object-cover"
    />
  } @else if (config().icon) {
    <app-icon
      [name]="config().icon!"
      [size]="iconSize[config().size]"
      color="var(--avatar-icon-color)"
    ></app-icon>
  } @else {
    <span
      [class]="
        'text-(--avatar-initials-color) font-(family-name:--avatar-font-family,var(--font-sans)) ' +
        textClass[config().size]
      "
    >
      {{ config().initials }}
    </span>
  }
</div>
